
import React from 'react';
import PropTypes from 'prop-types';
import { CatButton } from '@blocks-react/components/Button';

const DealerLocatorSelectStoreButton = ({
  isDisabled,
  onClick,
  isVisible,
  buttonText
}) => {
  if (!isVisible) return null;
  return (
    <CatButton
      disabled={isDisabled}
      onClick={onClick}
      type="button"
      variant="primary"
    >
      {buttonText}
    </CatButton>
  );
};

DealerLocatorSelectStoreButton.propTypes = {
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func,
  isVisible: PropTypes.bool,
  buttonText: PropTypes.string
};

export default DealerLocatorSelectStoreButton;